<template>
  <div class="form-group lm-number-input" v-if="isVisible" :class="{ row : isOnModeLabelOnLeft }">
    <label
      :for="idComputed"
      :title="titleComputed"
      :class=" {'col-sm-2': isOnModeLabelOnLeft, 'col-form-label': isOnModeLabelOnLeft }"
      class="text-truncate"
      >{{label}} <small v-if="required">*</small></label>
    <font-awesome-icon
      id="font-awesome-icon-edit"
      icon="edit"
      size="sm"
      class="clickable float-right mt-1"
      v-if="showEditButton"
      @click="$emit('edit-button-clicked')"
      />
    <div :class="{ 'col-sm-10': isOnModeLabelOnLeft }">
      <input
        :autofocus="autofocus"
        @input="$emit('input', $event.target.value)"
        :value="value"
        @focusout="validateOnfocusOutMethod"
        class="form-control"
        :class="{'is-invalid': v.$error}"
        :readonly="readonly"
        :placeholder="placeholder"
        onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
        type="number"
        :id="idComputed"
        :disabled="disabled"
        />
      <p class="invalid-feedback" v-if="!v.required"> {{ $t('field_required')}} </p>
      <p class="invalid-feedback" v-if="v.isValid === false"> {{ $t('field_invalid')}} </p>
      <p class="invalid-feedback" v-if="v.numeric === false"> {{ $t('number_required')}} </p>
      <p class="invalid-feedback" v-if="v.minLength === false"> {{ $tc('number_min_length', minLengthCharactersRequired )}} </p>
      <p class="invalid-feedback" v-if="v.maxLength === false"> {{ $tc('number_max_length', maxLengthCharactersAllowed )}} </p>
      <p class="invalid-feedback" v-if="v.exactLength === false"> {{ $tc('number_exact_length', exactLengthRequired )}} </p>
      <p class="invalid-feedback" v-if="v.sameAs !== undefined && !v.sameAs"> {{ $t('field_same_as') + labelOfFieldUsedForsameAsValidation }}</p>
    </div>
  </div>
</template>

<script>
import lmInputMixin from '@/mixins/lmInputMixin.js'
export default {
  mixins: [lmInputMixin]
}
</script>
